const emailConfigurationActionTypes = {
  FETCH_HOST_NAMES_SUCCESS: 'FETCH_HOST_NAMES_SUCCESS',
  FETCH_HOST_NAMES_FAILURE: 'FETCH_HOST_NAMES_FAILURE',
  NEWEMAILCONFIG_START_FETCH: 'NEWEMAILCONFIG_START_FETCH',
  NEWEMAILCONFIG_SUCCESS: 'NEWEMAILCONFIG_SUCCESS',
  NEWEMAILCONFIG_FAILURE: 'NEWEMAILCONFIG_FAILURE',
  CHECKCONNECTION_START_FETCH: 'CHECKCONNECTION_START_FETCH',
  CHECKCONNECTION_SUCCESS: 'CHECKCONNECTION_SUCCESS',
  CHECKCONNECTION_FAILURE: 'CHECKCONNECTION_FAILURE',
  EMAILCONFIG_START_FETCH: 'EMAILCONFIG_START_FETCH',
  FETCH_EMAILCONFIG_DETAILS_SUCCESS: 'FETCH_EMAILCONFIG_DETAILS_SUCCESS',
  FETCH_EMAILCONFIG_DETAILS_FAILURE: 'FETCH_EMAILCONFIG_DETAILS_FAILURE',
  EMAILCONFIG_SET_ERROR: 'EMAILCONFIG_SET_ERROR',
  FETCH_EMAILCONFIG_REQUEST: 'FETCH_EMAILCONFIG_REQUEST',
  EMAILCONFIG_DELETE_SUCCESS: 'EMAILCONFIG_DELETE_SUCCESS',
  EMAILCONFIG_DELETE_FAILURE: 'EMAILCONFIG_DELETE_FAILURE',
  REMOVE_EMAILCONFIG_DELETE_DATA: 'REMOVE_EMAILCONFIG_DELETE_DATA',
  CONFIG_FILTER_SUCCESS: 'CONFIG_FILTER_SUCCESS',
  CONFIG_FILTER_FAILURE: 'CONFIG_FILTER_FAILURE',
};

export default emailConfigurationActionTypes;
